'use strict';

function _get(target, property, receiver) {
    return (_get = 'undefined' != typeof Reflect && Reflect.get ? Reflect.get : function(target, property, receiver) {
        var base = _superPropBase(target, property);
        if (base) {
            var desc = Object.getOwnPropertyDescriptor(base, property);
            return desc.get ? desc.get.call(receiver) : desc.value
        }
    })(target, property, receiver || target)
}

function _superPropBase(object, property) {
    for (; !Object.prototype.hasOwnProperty.call(object, property) && null !== (object = _getPrototypeOf(object)););
    return object
}

function _typeof(obj) {
    return (_typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function(obj) {
        return typeof obj
    } : function(obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof objthem
    })(obj)
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function')
}

function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor)
    }
}

function _createClass(Constructor, protoProps, staticProps) {
    return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor
}

function _inherits(subClass, superClass) {
    if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function');
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: !0,
            configurable: !0
        }
    }), superClass && _setPrototypeOf(subClass, superClass)
}

function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function() {
        var result, Super = _getPrototypeOf(Derived);
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget)
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result)
    }
}

function _possibleConstructorReturn(self, call) {
    return !call || 'object' !== _typeof(call) && 'function' != typeof call ? _assertThisInitialized(self) : call
}

function _assertThisInitialized(self) {
    if (void 0 === self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    return self
}

function _wrapNativeSuper(Class) {
    var _cache = 'function' == typeof Map ? new Map : void 0;
    return (_wrapNativeSuper = function(Class) {
        if (null === Class || !_isNativeFunction(Class)) return Class;
        if ('function' != typeof Class) throw new TypeError('Super expression must either be null or a function');
        if (void 0 !== _cache) {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper)
        }

        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor)
        }
        return Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(Wrapper, Class)
    })(Class)
}

function _construct(Parent, args, Class) {
    return (_construct = _isNativeReflectConstruct() ? Reflect.construct : function(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var instance = new(Function.bind.apply(Parent, a));
        return Class && _setPrototypeOf(instance, Class.prototype), instance
    }).apply(null, arguments)
}

function _isNativeReflectConstruct() {
    if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ('function' == typeof Proxy) return !0;
    try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], (function() {}))), !0
    } catch (e) {
        return !1
    }
}

function _isNativeFunction(fn) {
    return -1 !== Function.toString.call(fn).indexOf('[native code]')
}

function _setPrototypeOf(o, p) {
    return (_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
        return o.__proto__ = p, o
    })(o, p)
}

function _getPrototypeOf(o) {
    return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
        return o.__proto__ || Object.getPrototypeOf(o)
    })(o)
}
var SearchForm = function(_HTMLElement) {
        _inherits(SearchForm, _wrapNativeSuper(HTMLElement));
        var _super = _createSuper(SearchForm);

        function SearchForm() {
            var _this;
            return _classCallCheck(this, SearchForm), (_this = _super.call(this)).input = _this.querySelector('input[type="search"]'), _this.resetButton = _this.querySelector('button[type="reset"]'), _this.input && (_this.input.form.addEventListener('reset', _this.onFormReset.bind(_assertThisInitialized(_this))), _this.input.addEventListener('input', debounce((function(event) {
                _this.onChange(event)
            }), 300).bind(_assertThisInitialized(_this)))), _this
        }
        return _createClass(SearchForm, [{
            key: 'toggleResetButton',
            value: function() {
                var resetIsHidden = this.resetButton.classList.contains('hidden');
                this.input.value.length > 0 && resetIsHidden ? this.resetButton.classList.remove('hidden') : 0 !== this.input.value.length || resetIsHidden || this.resetButton.classList.add('hidden')
            }
        }, {
            key: 'onChange',
            value: function() {
                this.toggleResetButton()
            }
        }, {
            key: 'shouldResetForm',
            value: function() {
                return !document.querySelector('[aria-selected="true"] a')
            }
        }, {
            key: 'onFormReset',
            value: function(event) {
                event.preventDefault(), this.shouldResetForm() && (this.input.value = '', this.input.focus(), this.toggleResetButton())
            }
        }]), SearchForm
    }(),
    PredictiveSearch = function(_SearchForm) {
        _inherits(PredictiveSearch, SearchForm);
        var _super2 = _createSuper(PredictiveSearch);

        function PredictiveSearch() {
            var _this2;
            return _classCallCheck(this, PredictiveSearch), (_this2 = _super2.call(this)).cachedResults = {}, _this2.predictiveSearchResults = _this2.querySelector('[data-predictive-search]'), _this2.allPredictiveSearchInstances = document.querySelectorAll('predictive-search'), _this2.isOpen = !1, _this2.abortController = new AbortController, _this2.searchTerm = '', _this2.setupEventListeners(), _this2
        }
        return _createClass(PredictiveSearch, [{
            key: 'setupEventListeners',
            value: function() {
                this.input.form.addEventListener('submit', this.onFormSubmit.bind(this)), this.input.addEventListener('focus', this.onFocus.bind(this)), this.addEventListener('focusout', this.onFocusOut.bind(this)), this.addEventListener('keyup', this.onKeyup.bind(this)), this.addEventListener('keydown', this.onKeydown.bind(this))
            }
        }, {
            key: 'getQuery',
            value: function() {
               return this.input.value.trim().toUpperCase();
            }
        }, {
            key: 'onChange',
            value: function() {
                _get(_getPrototypeOf(PredictiveSearch.prototype), 'onChange', this).call(this);
                var _this$querySelector, newSearchTerm = this.getQuery();
                this.searchTerm && newSearchTerm.startsWith(this.searchTerm) || (null === (_this$querySelector = this.querySelector('#predictive-search-results-groups-wrapper')) || void 0 === _this$querySelector || _this$querySelector.remove());
                this.updateSearchForTerm(this.searchTerm, newSearchTerm), this.searchTerm = newSearchTerm, this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.close(!0)
            }
        }, {
            key: 'onFormSubmit',
            value: function(event) {
                this.getQuery().length && !this.querySelector('[aria-selected="true"] a') || event.preventDefault()
            }
        }, {
            key: 'onFormReset',
            value: function(event) {
                _get(_getPrototypeOf(PredictiveSearch.prototype), 'onFormReset', this).call(this, event), _get(_getPrototypeOf(PredictiveSearch.prototype), 'shouldResetForm', this).call(this) && (this.searchTerm = '', this.abortController.abort(), this.abortController = new AbortController, this.closeResults(!0))
            }
        }, {
            key: 'onFocus',
            value: function() {
                var currentSearchTerm = this.getQuery();
                currentSearchTerm.length && (this.searchTerm !== currentSearchTerm ? this.onChange() : 'true' === this.getAttribute('results') ? this.open() : this.getSearchResults(this.searchTerm))
            }
        }, {
            key: 'onFocusOut',
            value: function() {
                var _this3 = this;
                setTimeout((function() {
                    _this3.contains(document.activeElement) || _this3.close()
                }))
            }
        }, {
            key: 'onKeyup',
            value: function(event) {
                switch (this.getQuery().length || this.close(!0), event.preventDefault(), event.code) {
                    case 'ArrowUp':
                        this.switchOption('up');
                        break;
                    case 'ArrowDown':
                        this.switchOption('down');
                        break;
                    case 'Enter':
                        this.selectOption()
                }
            }
        }, {
            key: 'onKeydown',
            value: function(event) {
                'ArrowUp' !== event.code && 'ArrowDown' !== event.code || event.preventDefault()
            }
        }, {
            key: 'updateSearchForTerm',
            value: function(previousTerm, newTerm) {
                var searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]'),
                    currentButtonText = null == searchForTextElement ? void 0 : searchForTextElement.innerText;
                if (currentButtonText) {
                    if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) return;
                    var newButtonText = currentButtonText.replace(previousTerm, newTerm);
                    searchForTextElement.innerText = newButtonText
                }
            }
        }, {
            key: 'switchOption',
            value: function(direction) {
                if (this.getAttribute('open')) {
                    var moveUp = 'up' === direction,
                        selectedElement = this.querySelector('[aria-selected="true"]'),
                        allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter((function(element) {
                            return null !== element.offsetParent
                        })),
                        activeElementIndex = 0;
                    if (!moveUp || selectedElement) {
                        for (var selectedElementIndex = -1, i = 0; - 1 === selectedElementIndex && i <= allVisibleElements.length;) allVisibleElements[i] === selectedElement && (selectedElementIndex = i), i++;
                        if (this.statusElement.textContent = '', !moveUp && selectedElement ? activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1 : moveUp && (activeElementIndex = 0 === selectedElementIndex ? allVisibleElements.length - 1 : selectedElementIndex - 1), activeElementIndex !== selectedElementIndex) {
                            var activeElement = allVisibleElements[activeElementIndex];
                            activeElement.setAttribute('aria-selected', !0), selectedElement && selectedElement.setAttribute('aria-selected', !1), this.input.setAttribute('aria-activedescendant', activeElement.id)
                        }
                    }
                }
            }
        }, {
            key: 'selectOption',
            value: function() {
                var selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
                selectedOption && selectedOption.click()
            }
        }, {
            key: 'getSearchResults',
            value: function(searchTerm) {
              
                var _this4 = this,
                    queryKey = searchTerm.replace(' ', '-').toLowerCase();
                this.setLiveRegionLoadingState(), this.cachedResults[queryKey] ? this.renderSearchResults(this.cachedResults[queryKey]) : fetch(''.concat(Station.Theme.routes.predictive_search_url, '?q=').concat(encodeURIComponent(searchTerm), '&section_id=predictive-search'), {
                    signal: this.abortController.signal
                }).then((function(response) {
                    if (!response.ok) {
                        var error = new Error(response.status);
                        throw _this4.close(), error
                    }
                    return response.text()
                })).then((function(text) {
                    var resultsMarkup = (new DOMParser).parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                    _this4.allPredictiveSearchInstances.forEach((function(predictiveSearchInstance) {
                        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup
                    })), _this4.renderSearchResults(resultsMarkup)
                })).catch((function(error) {
                    if (20 !== (null == error ? void 0 : error.code)) throw _this4.close(), error
                }))
            }
        }, {
            key: 'setLiveRegionLoadingState',
            value: function() {
                this.statusElement = this.statusElement || this.querySelector('.predictive-search-status'), this.loadingText = this.loadingText || this.getAttribute('data-loading-text'), this.setLiveRegionText(this.loadingText), this.setAttribute('loading', !0)
            }
        }, {
            key: 'setLiveRegionText',
            value: function(statusText) {
                var _this5 = this;
                this.statusElement.setAttribute('aria-hidden', 'false'), this.statusElement.textContent = statusText, setTimeout((function() {
                    _this5.statusElement.setAttribute('aria-hidden', 'true')
                }), 1e3)
            }
        }, {
            key: 'renderSearchResults',
            value: function(resultsMarkup) {
                this.predictiveSearchResults.innerHTML = resultsMarkup, this.setAttribute('results', !0), this.setLiveRegionResults(), this.open()
            }
        }, {
            key: 'setLiveRegionResults',
            value: function() {
                this.removeAttribute('loading'), this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent)
            }
        }, {
            key: 'getResultsMaxHeight',
            value: function() {
                return this.resultsMaxHeight = window.innerHeight - document.querySelector('#app-header').getBoundingClientRect().bottom, this.resultsMaxHeight
            }
        }, {
            key: 'open',
            value: function() {
                this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || ''.concat(this.getResultsMaxHeight(), 'px'), this.setAttribute('open', !0), this.input.setAttribute('aria-expanded', !0), this.isOpen = !0
            }
        }, {
            key: 'close',
            value: function() {
                var clearSearchTerm = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                this.closeResults(clearSearchTerm), this.isOpen = !1
            }
        }, {
            key: 'closeResults',
            value: function() {
                var clearSearchTerm = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                clearSearchTerm && (this.input.value = '', this.removeAttribute('results'));
                var selected = this.querySelector('[aria-selected="true"]');
                selected && selected.setAttribute('aria-selected', !1), this.input.setAttribute('aria-activedescendant', ''), this.removeAttribute('loading'), this.removeAttribute('open'), this.input.setAttribute('aria-expanded', !1), this.resultsMaxHeight = !1, this.predictiveSearchResults.removeAttribute('style')
            }
        }]), PredictiveSearch
    }();
customElements.define('predictive-search', PredictiveSearch);